import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randBook } from "@ngneat/falso";

type Options = Exclude<Parameters<typeof randBook>[0], undefined>;
type BookCategory = Exclude<Options["category"], undefined> | "";

const bookCategories: Record<BookCategory, string> = {
  "": "",
  Comedy: "Comedy",
  Crime: "Crime",
  "Family and Self": "Family and Self",
  Love: "Love",
  "Science Fiction and Fantasy": "Science Fiction and Fantasy",
  "State of the Nation": "State of the Nation",
  "War and Travel": "War and Travel",
};

export const randBookNodeDef = createNodeDef({
  type: "randBook",
  displayName: "Book",
  defaultName: "book",
  fields: [
    {
      type: DataFieldType.SELECT,
      key: "category",
      label: "Category",
      options: bookCategories,
    },
  ],
  initialData: (): { category: BookCategory } => ({ category: "" }),
  generate: ({ node }) => {
    return randBook({ category: node.data.category || undefined });
  },
});
